import { useState } from "react";
import { MarketingLayout } from "../components/MarketingLayout";
// Shared with scripts/seo-build.js, which emits the FAQPage schema from
// this same file — schema that disagrees with the visible copy is a
// structured-data violation.
import FAQS from "../data/faq.json";


export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <MarketingLayout>
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="marquee-tag mb-4">// FAQ</div>
        <h1 className="font-display font-black type-title-lg tracking-tighter mb-10">QUESTIONS.</h1>
        <div className="space-y-0 brutal-border">
          {FAQS.map((f, i) => (
            <div key={i} className="border-b brutal-border border-l-0 border-r-0 border-t-0 last:border-b-0">
              <button
                type="button"
                className="w-full text-left p-6 flex justify-between items-start gap-4 hover:bg-surface transition-colors"
                onClick={() => setOpen(open === i ? -1 : i)}
              >
                <span className="font-display font-bold type-subheading">{f.q}</span>
                <span className="text-ink-accent text-xl shrink-0">{open === i ? "−" : "+"}</span>
              </button>
              {open === i && <div className="px-6 pb-6 text-sm text-ink-muted leading-relaxed">{f.a}</div>}
            </div>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
